var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M383.8,509.15H191.68a13,13,0,1,0,0,26H383.8a13,13,0,0,0,0-26Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.48,142.62a91.07,91.07,0,0,0-163.19-41L136.66,340.71a13.11,13.11,0,0,0-2.52,6.71L121.57,505A13,13,0,0,0,140,517.78l137.94-64.43a13.09,13.09,0,0,0,4.92-4L460.49,210.22h0A90.46,90.46,0,0,0,477.48,142.62Zm-37.83,52.11h0L264,431.21l-89.72,41.91-.65-.5c-7.35-5.46-14.75-10.63-22.17-15.58L158.71,366l68.55,50.92a13,13,0,0,0,15.48-20.84l-74-55,166.4-224a65.1,65.1,0,0,1,104.51,77.64Z",
    style: {
      fill: "green"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreen);
export default __webpack_public_path__ + "static/media/edit_green.60e136444c627402eb729942eb02cb27.svg";
export { ForwardRef as ReactComponent };